import OutcomeType from "@/constants/OutcomeType";

export default Object.freeze( {
	[ OutcomeType.NOTE ]: "/note",
	[ OutcomeType.DECISION ]: "/decision",
	[ OutcomeType.COMMITMENT ]: "/commitment",
} );



// WEBPACK FOOTER //
// ./src/constants/TextTriggers.js